import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { Button, Form, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faSave } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import useFetch from "../../../../hooks/useFetch";

export default function Subcategoria() {
    const { id_cat, id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const { get, post, put } = useFetch();

    const [state, setState] = useState({
        acao: location.state?.acao || (id === "criar" ? "Criar" : "Visualizar"),
        dados: { nome_subcategoria: "", id_categoria: id_cat }
    });

    useEffect(() => {
        if (id !== "criar") {
            get(`/subcategoriafotografia/${id}`).then(r => {
                if (r.ok) setState(s => ({ ...s, dados: r.result.data }));
            });
        }
    }, [id]);

    const salvar = async () => {
        if (!state.dados.nome_subcategoria) {
            Swal.fire({ title: "Preencha o nome da subcategoria", icon: "warning", confirmButtonColor: "#587b7f" });
            return;
        }
        const method = id === "criar" ? post : put;
        const url = id === "criar" ? '/subcategoriafotografia' : `/subcategoriafotografia/${id}`;
        const response = await method(url, { nome_subcategoria: state.dados.nome_subcategoria, id_categoria: id_cat });
        if (response.status === 200 || response.status === 201) {
            Swal.fire({ title: "Subcategoria salva!", icon: "success", confirmButtonColor: "#587b7f" });
            navigate(`/admin/iconografico/categorias/${id_cat}/subcategorias`);
        } else {
            Swal.fire({ title: "Não foi possível salvar a subcategoria", icon: "error", confirmButtonColor: "#587b7f" });
        }
    };

    const somenteLeitura = state.acao === "Visualizar";

    return (
        <div className="admin-page-container">
            <div className="mb-4">
                <Link to={`/admin/iconografico/categorias/${id_cat}/subcategorias`} className="btn-back-modern">
                    <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Voltar
                </Link>
            </div>

            <Card className="filter-card-admin">
                <Card.Body className="p-4 p-md-5">
                    <div className="section-title-modern mb-5">
                        <div className="title-accent"></div>
                        <div>
                            <h2 className="admin-title">{state.acao} Subcategoria</h2>
                            <p className="admin-subtitle small mb-0">Refine a classificação do seu acervo</p>
                        </div>
                    </div>

                    <Form>
                        <Form.Group className="mb-4">
                            <Form.Label className="label-admin">* Nome da Subcategoria</Form.Label>
                            <Form.Control
                                className="input-moderno"
                                value={state.dados.nome_subcategoria}
                                onChange={e => setState({ ...state, dados: { ...state.dados, nome_subcategoria: e.target.value } })}
                                disabled={somenteLeitura}
                            />
                        </Form.Group>

                        {!somenteLeitura && (
                            <div className="d-flex justify-content-end mt-5 pt-3 border-top">
                                <Button className="btn-apply-filters px-5" onClick={salvar}>
                                    <FontAwesomeIcon icon={faSave} className="me-2" /> Salvar Subcategoria
                                </Button>
                            </div>
                        )}
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
}
